import { useQuery } from "@tanstack/react-query";
import { Member } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { memberQueryKeys } from "./keys";


const getData = async (scenarioId: string) => {
    const res = await memberRepository.find(scenarioId);
    return res.data?.data;
};

export const useMembers = (scenarioId: string) => {
    return useQuery<Member[]>({
        queryKey: memberQueryKeys.all(scenarioId),
        queryFn: async () => getData(scenarioId),
        retry: false
    });
};
